// Pacchetti BIA nel checkout (devops #213): 3/6 BIA e annuale sono variazioni del prodotto BIA con attributo
// `biaCredits` (api#314); i prezzi li imposta Walter dal catalogo. Logica pura, provata senza browser
// (src/utils/biaPack.test.mjs). Senza variazioni pacchetto (oggi in produzione) ogni funzione ricade sul
// comportamento di sempre: BIA singola al prezzo del prodotto, checkout invariato.

/** Variazioni attive che sono pacchetti (più di un credito). La BIA singola resta il prodotto stesso. */
export function biaPacksFromProduct(product) {
    const vars = Array.isArray(product?.variations) ? product.variations : [];
    return vars
        .filter(v => v && v.active !== false && Number(v.price) > 0 && Number(v?.attributes?.biaCredits) > 1)
        .map(v => ({
            name: v.variationName,
            label: v.variationName,
            credits: Number(v.attributes.biaCredits),
            price: Number(v.price),
        }));
}

export function findBiaPack(packs, name) {
    if (!name) return null;
    return (packs || []).find(p => p.name === name) || null;
}

/** Prezzo pieno della voce BIA: quello del pacchetto scelto, altrimenti il prezzo del prodotto (singola, con prezzo trainer). */
export function biaBasePrice(pack, productPrice) {
    return pack ? Number(pack.price) : (productPrice || 0);
}

/** Etichetta della riga nel riepilogo ordine: voce separata e leggibile per il pacchetto. */
export function biaSummaryLabel(pack) {
    return pack ? `BIA – ${pack.label}:` : 'BIA:';
}

/** `additionals` dell'upsell BIA: con un pacchetto si aggiunge il variationName, che sceglie la variazione lato server. */
export function biaAdditionals(trainerId, pack) {
    const additionals = { trainerId };
    if (pack) additionals.variationName = pack.name;
    return additionals;
}
